import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import CreatableSelect from 'react-select/creatable'
import {confirm} from 'react-confirm-box'
import './Subscriber.scss'
import {OptionName} from '../Constant/SelectOption'
import {
  CreateDataPost,
  CreateData as subscriberCreate,
} from '../../AllContactsList/SubscriberSlice/SubscriberSlice'
import {CreateData, getalltagsdata} from '../../Tags/TagSlice/TagsSlices'
import {AuthenticateUser} from '../../../../../Utils/_helpers/RoleAndPermission'

const optionsWithLabelChange = {
  closeOnOverlayClick: false,
  labels: {
    confirmable: 'Confirm',
    cancellable: 'Cancel',
  },
}
const AddTagToSubscriber = ({
  show,
  handleClose,
  data,
  mapped,
  finalData,
  setFinalData,
  close,
  setFieldName,
  setMapped,
  setDisableoption,
  closeUpload,
}: any) => {
  const dispatch = useDispatch()
  const tagslist = useSelector((state: any) => state?.tags?.allTags?.data)

  const groupid: any = useSelector((state: any) => state?.subscriberData?.FieldName?.data?._id)

  const [tag, setTag] = useState<any>([])
  const [selectedTag, setSelectedTag] = useState<any>([])

  useEffect(() => {
    dispatch(getalltagsdata())
  }, [])

  useEffect(() => {
    const filteredTags = tagslist?.filter((val: any) => {
      if (val?.type) {
        return val?.isHidden === false && val?.type !== 'list'
      }
      return val?.isHidden === false
    })
    let listData = filteredTags?.map((val: any) => ({value: val?._id, label: val?.name}))
    setTag(listData)
  }, [tagslist])

  const handleChange = async (e: any) => {
    setSelectedTag(e)
  }

  const handleSubmmit = () => {
    let data1 = new FormData()
    let Findids = tagslist
      ?.map((val: any) => {
        if (selectedTag?.find((key: any) => key?.label == val?.name) !== undefined) {
          return val?._id
        }
      })
      ?.filter((key: any) => key !== undefined)

    let ff: any = {
      name: finalData?.name,
      file: finalData?.file,
      mergeLabels: JSON.stringify(mapped),
      tagIds: JSON.stringify([...Findids]),
    }

    for (var key in ff) {
      data1.append(key, ff[key])
    }

    groupid !== undefined ? dispatch(CreateDataPost(data1)) : dispatch(subscriberCreate(data1))
    handleClose()
    setFieldName(OptionName)
    close()
    setMapped([])
    setDisableoption([])
    closeUpload()
  }

  const handleCreate = async (e: any) => {
    // if(/^[a-zA-Z0-9_]{2,25}+$/g.test(e)){
    let confirNew = await confirm(
      'Are you sure you want to create a new tag?',
      optionsWithLabelChange
    )
    setSelectedTag([...selectedTag, {value: e, label: e}])
    confirNew &&
      dispatch(
        CreateData({
          name: e,
        })
      )
    // }
  }
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        className='free_modal'
        dialogClassName='modal-dialog-centered'
      >
        {AuthenticateUser('create-tag') && (
          <>
            <div className='modal-header'>
              <h2>ADD TAG</h2>
            </div>
            <div className='modal-body pt-8'>
              <CreatableSelect
                onCreateOption={handleCreate}
                isOptionSelected={selectedTag}
                value={selectedTag}
                isMulti
                options={tag}
                onChange={handleChange}
              />
            </div>
            <div className='modal-footer w-100'>
              <button onClick={handleClose} type='button' className='btn btn-light-primary'>
                Cancel
              </button>
              <button onClick={handleSubmmit} id='submit' type='button' className='btn btn-primary'>
                Submit
              </button>
            </div>
          </>
        )}
      </Modal>
    </>
  )
}

export default AddTagToSubscriber
